import { MainLayout } from 'components/layout/mainLayout'
import { MainPage, ProfilePage } from 'blocks'
import {Header} from 'components/layout/header'

export const Profile = () => {
  return (
    <MainLayout>
      <Header isShowMenu />
      <MainPage />
      <ProfilePage />
    </MainLayout>
  )
}
